import { defineMessages } from "react-intl";

export const messages = defineMessages({
  step01: {
    id: "guides.proSomnusCreateDeal.tour.step01",
    defaultMessage: "Create a deal",
    description: "ProSomnus Create Deal tour, step 1 (add menu) title",
  },
  step01Description: {
    id: "guides.proSomnusCreateDeal.tour.step01.description",
    defaultMessage: "In order to create a deal, let’s click this menu.",
    description: "ProSomnus Create Deal tour, step 1 (add menu) message",
  },
  step02: {
    id: "guides.proSomnusCreateDeal.tour.step02",
    defaultMessage: "Add Deal",
    description: "ProSomnus Create Deal tour, step 2 (add deal menu item) title",
  },
  step02Description: {
    id: "guides.proSomnusCreateDeal.tour.step02.description",
    defaultMessage: "Select “Add Deal”.",
    description: "ProSomnus Create Deal tour, step 2 (add deal menu item) message",
  },
  step03: {
    id: "guides.proSomnusCreateDeal.tour.step03",
    defaultMessage: "Deal name",
    description: "ProSomnus Create Deal tour, step 3 (deal name field) title",
  },
  step03Description: {
    id: "guides.proSomnusCreateDeal.tour.step03.description",
    defaultMessage: "Enter your Name (ex: Physician Office + Physician Name).",
    description: "ProSomnus Create Deal tour, step 3 (deal name field) message",
  },
  step04: {
    id: "guides.proSomnusCreateDeal.tour.step04",
    defaultMessage: "Funnel",
    description: "ProSomnus Create Deal tour, step 4 (funnel field) title",
  },
  step04Description: {
    id: "guides.proSomnusCreateDeal.tour.step04.description",
    defaultMessage: "Under Funnel, select “North America - Referral Initiative Funnel”.",
    description: "ProSomnus Create Deal tour, step 4 (funnel field) message",
  },
  step05: {
    id: "guides.proSomnusCreateDeal.tour.step05",
    defaultMessage: "Stage",
    description: "ProSomnus Create Deal tour, step 5 (stage field) title",
  },
  step05Description: {
    id: "guides.proSomnusCreateDeal.tour.step05.description",
    defaultMessage: "For stage, choose the current stage of your deal.",
    description: "ProSomnus Create Deal tour, step 5 (stage field) message",
  },
  step06: {
    id: "guides.proSomnusCreateDeal.tour.step06",
    defaultMessage: "Other fields",
    description: "ProSomnus Create Deal tour, step 6 (remaining fields) title",
  },
  step06Description: {
    id: "guides.proSomnusCreateDeal.tour.step06.description",
    defaultMessage:
      "Next you can fill in the remaining fields, such as Opportunity (Rx per month), Closing date (enter x date from start), Name of Networked Center (Dentist First_Lastname), Company or Person (Physician), and others if necessary.",
    description: "ProSomnus Create Deal tour, step 6 (remaining fields) message",
  },
  step07: {
    id: "guides.proSomnusCreateDeal.tour.step07",
    defaultMessage: "Create your deal",
    description: "ProSomnus Create Deal tour, step 7 (create button) title",
  },
  step07Description: {
    id: "guides.proSomnusCreateDeal.tour.step07.description",
    defaultMessage: "When all is ready, click here to create a Deal.",
    description: "ProSomnus Create Deal tour, step 7 (create button) message",
  },
  step08: {
    id: "guides.proSomnusCreateDeal.tour.step08",
    defaultMessage: "Records",
    description: "ProSomnus Create Deal tour, step 8 (records menu) title",
  },
  step08Description: {
    id: "guides.proSomnusCreateDeal.tour.step08.description",
    defaultMessage: "To find your deal in your pipeline, go to the navigation bar - Records.",
    description: "ProSomnus Create Deal tour, step 8 (records menu) message",
  },
  step09: {
    id: "guides.proSomnusCreateDeal.tour.step09",
    defaultMessage: "Deals and Funnels",
    description: "ProSomnus Create Deal tour, step 9 (deals menu item) title",
  },
  step09Description: {
    id: "guides.proSomnusCreateDeal.tour.step09.description",
    defaultMessage: "Now click here.",
    description: "ProSomnus Create Deal tour, step 9 (deals menu item) message",
  },
  step10: {
    id: "guides.proSomnusCreateDeal.tour.step10",
    defaultMessage: "Kanban view",
    description: "ProSomnus Create Deal tour, step 10 (view toggle) title",
  },
  step10Description: {
    id: "guides.proSomnusCreateDeal.tour.step10.description",
    defaultMessage: "Let’s go to the Kanban view.",
    description: "ProSomnus Create Deal tour, step 10 (view toggle) message",
  },
  step11: {
    id: "guides.proSomnusCreateDeal.tour.step11",
    defaultMessage: "Funnel pipeline",
    description: "ProSomnus Create Deal tour, step 11 (kanban funnel selector) title",
  },
  step11Description: {
    id: "guides.proSomnusCreateDeal.tour.step11.description",
    defaultMessage:
      "Select the funnel pipeline: “North America - Referral Initiative Funnel” to see the created deal.",
    description: "ProSomnus Create Deal tour, step 11 (kanban funnel selector) message",
  },
  step12: {
    id: "guides.proSomnusCreateDeal.tour.step12",
    defaultMessage: "Progress your deal",
    description: "ProSomnus Create Deal tour, step 12 (drag and drop) title",
  },
  step12Description: {
    id: "guides.proSomnusCreateDeal.tour.step12.description",
    defaultMessage: "Drag and drop your deal to progress it between stages.",
    description: "ProSomnus Create Deal tour, step 12 (drag and drop) message",
  },
});

export const errorMessages = defineMessages({
  noTargetFunnel: {
    id: "guides.proSomnusCreateDeal.tour.error.noTargetFunnel",
    defaultMessage:
      "This tour requires a funnel named “North America - Referral Initiative Funnel”, but your organization doesn’t have one.",
    description:
      "ProSomnus Create Deal tour, error shown when the required funnel is missing in the org",
  },
});
